import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import {
  ADDRESS_LINES,
  PHONE_1,
  PHONE_2,
  PHONE_1_LINK,
  PHONE_2_LINK,
  WHATSAPP_LINK,
} from "../data/content";
import { useEnquiry } from "../context/EnquiryContext";

const NAV = [
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/industries", label: "Industries" },
  { to: "/brands", label: "Brands" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper">
      <div className="px-5 sm:px-8 lg:px-12 pt-16 sm:pt-24 pb-12 border-b border-paper/15">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10">
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.88] text-[11.5vw] lg:text-[8.5rem]">
            Jagdamba
            <br />
            Enterprises
          </h2>
          <button
            data-testid="footer-cta-send-requirement"
            onClick={() => openEnquiry("")}
            className="inline-flex items-center gap-3 bg-accent text-ink font-mono text-xs tracking-[0.2em] uppercase px-7 py-4 hover:bg-paper transition-colors duration-300 self-start"
          >
            Send Your Requirement <ArrowUpRight size={14} />
          </button>
        </div>
        <p className="mt-8 font-mono text-[11px] tracking-[0.25em] uppercase text-paper/50">
          Hardware &amp; Industrial Solutions — Reliable | Genuine | On-Time
        </p>
      </div>

      <div className="px-5 sm:px-8 lg:px-12 py-12 grid grid-cols-1 sm:grid-cols-3 gap-10 border-b border-paper/15">
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-paper/40 mb-5">Navigate</p>
          <ul className="space-y-2">
            {NAV.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="link-underline text-sm text-paper/80 hover:text-paper"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-paper/40 mb-5">Contact</p>
          <ul className="space-y-2 text-sm text-paper/80">
            <li>
              <a data-testid="footer-phone-1" href={PHONE_1_LINK} className="link-underline hover:text-paper">
                {PHONE_1}
              </a>
            </li>
            <li>
              <a data-testid="footer-phone-2" href={PHONE_2_LINK} className="link-underline hover:text-paper">
                {PHONE_2}
              </a>
            </li>
            <li>
              <a
                data-testid="footer-whatsapp-link"
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline hover:text-paper"
              >
                WhatsApp Us
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-paper/40 mb-5">Address</p>
          <address className="not-italic text-sm text-paper/80 leading-relaxed">
            {ADDRESS_LINES.map((line) => (
              <span key={line} className="block">
                {line}
              </span>
            ))}
          </address>
        </div>
      </div>

      <div className="px-5 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3">
        <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-paper/40">
          © 2026 Jagdamba Enterprises. All Rights Reserved.
        </p>
        <p className="font-mono text-[11px] tracking-[0.15em] uppercase text-paper/40">
          Made with ❤️ by{" "}
          <a
            data-testid="footer-credit-link"
            href="https://dotsandcommas.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="link-underline text-paper/60 hover:text-accent transition-colors"
          >
            Dots and Commas
          </a>
        </p>
      </div>
    </footer>
  );
};
